<template>
    <app-popover v-bind="$attrs" class="submit-form-wrapper" ref="popover" :inherit-width="viewSize.xsDown">
        <template #default="{toggle}">
            <form-input-submit name="action_save" :id="_id" :required="_required" class="submit-form button button-save" v-bind="$attrs" :disabled="disabled">
                <slot><i class="material-icons" aria-hidden="true" v-text="SubmitIcons.save" role="img"></i> Speichern</slot>
            </form-input-submit><!-- --><span class="submit-form-extender button button-save" @click="toggle" @keypress.prevent.space @keyup.prevent.space="toggle"
            @keyup.prevent.enter="toggle" ref="openSaveOptionsHandler"
            aria-label="Speicher-Optionen ausklappen" role="button" tabindex="0">
                <i class="material-icons no-padding" :class="{disabled}" aria-hidden="true" role="img">arrow_drop_down</i>
            </span>
        </template>
        <template #container>
            <div class="submit-buttons-wrapper">
                <slot name="options">
                    <div class="submit-button-row">
                        <form-input-submit size="long" name="save_list" class="button button-save" v-bind="$attrs" :disabled="disabled"
                            aria-label="Speichern und zur Liste" ref="saveToList">
                            <span aria-hidden="true">Speichern und zur Liste</span>
                        </form-input-submit>
                    </div>
                    <div class="submit-button-row">
                        <form-input-submit size="long" name="save_view" class="button button-save" v-bind="$attrs" :disabled="disabled"
                            aria-label="Speichern und zur Ansicht">
                            <span aria-hidden="true">Speichern und zur Ansicht</span>
                        </form-input-submit>
                    </div>
                </slot>
            </div>
        </template>
    </app-popover>
</template>

<script lang="ts">
    import {Component, Prop} from 'vue-facing-decorator';
    import {SubmitIcons} from '@/library/design';
    import AppPopover from '../AppPopover.vue';
    import {FormInput} from './FormInput.vue';
    import FormInputSubmit from './FormInputSubmit.vue';

    @Component({
        name: 'FormInputSave',
        components: {
            AppPopover,
            FormInputSubmit,
        },
        inheritAttrs: false,
    })
    export default class FormInputSave extends FormInput
    {
        readonly $refs: { popover: AppPopover, saveToList: FormInputSave, openSaveOptionsHandler: HTMLSpanElement };

        @Prop({
            type: Boolean,
            default: false,
            required: false,
        }) disabled: boolean;

        SubmitIcons = SubmitIcons;

        mounted(): void
        {
            this.$refs.popover.emitter.on('open', () => (this.$refs.saveToList?.$el as HTMLButtonElement)?.focus());
            this.$refs.popover.emitter.on('close', () => this.$refs.openSaveOptionsHandler.focus());
        }
    };
</script>